import React from "react";

const SpecifiedCommercialTransactions: React.FC = () => {
  return (
    <div className="min-h-screen">
      <section className="relative pt-40 pb-24 overflow-hidden bg-[#1B2A4A]">
        <div className="absolute inset-0 bg-[#4A6FA5]/10" />
        <div className="relative mx-auto max-w-6xl px-5 lg:px-6">
          <div className="flex justify-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#B8860B]/40 bg-[#B8860B]/10 px-4 py-1.5 mb-8">
              <span className="text-sm font-semibold text-[#B8860B]">Commercial Transactions</span>
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-[3.3rem] font-bold text-center text-[#F5F3EF] leading-tight">
            特定商取引法に基づく表記
          </h1>
        </div>
      </section>

      <section className="py-16 lg:py-20 bg-[#F5F3EF]">
        <div className="mx-auto max-w-3xl px-5 lg:px-6">
          <p className="text-[#5A6577] mb-8 text-justify leading-relaxed">
            特定商取引法に基づき、以下の通り表示いたします。
          </p>

          <div className="space-y-8">
            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                販売事業者名
              </h2>
              <p className="text-[#5A6577]">株式会社Senrigan</p>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                代表責任者
              </h2>
              <p className="text-[#5A6577]">代表取締役 宮川 清実</p>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                所在地
              </h2>
              <p className="text-[#5A6577]">
                〒731-0137
                <br />
                広島県広島市安佐南区山本2-3-35
              </p>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                電話番号
              </h2>
              <p className="text-[#5A6577]">082-209-0181</p>
              <p className="text-sm text-[#7B8794] mt-1">
                受付時間：平日 10:00〜17:00
              </p>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                メールアドレス
              </h2>
              <p className="text-[#5A6577]">
                <span className="select-all">info</span>
                <span className="text-[#7B8794] mx-1">[at]</span>
                <span className="select-all">senrigan</span>
                <span className="text-[#7B8794] mx-1">[dot]</span>
                <span className="select-all">systems</span>
              </p>
              <p className="text-sm text-[#7B8794] mt-2">
                ※ [at]を@に、[dot]を.に置き換えてください
              </p>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                販売価格
              </h2>
              <div className="text-[#5A6577] space-y-2">
                <p>
                  サービス内容により異なります。詳細はお見積りにてご提示いたします。
                </p>
                <div className="ml-4 space-y-1">
                  <p>・LP・Webサイト制作：10万円〜</p>
                  <p>・業務Webアプリ開発：30万円〜</p>
                  <p>・基幹システム開発：100万円〜</p>
                </div>
                <p className="text-sm text-[#7B8794]">
                  ※上記は参考価格です。詳細な仕様により価格は変動いたします。
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                料金の支払方法
              </h2>
              <div className="text-[#5A6577] space-y-2">
                <p>以下の方法でお支払いいただけます：</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>銀行振込（前払い）</li>
                  <li>請求書払い（月末締め翌月末払い）</li>
                </ul>
                <p className="text-sm text-[#7B8794] mt-2">
                  ※振込手数料はお客様負担となります。
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                商品代金以外の必要料金
              </h2>
              <div className="text-[#5A6577] space-y-2">
                <ul className="list-disc ml-6 space-y-1">
                  <li>消費税（10%）</li>
                  <li>銀行振込手数料（お客様負担）</li>
                  <li>サーバー・ドメイン費用（実費）</li>
                  <li>第三者ライセンス費用（該当する場合）</li>
                </ul>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                商品の引渡し時期
              </h2>
              <div className="text-[#5A6577] space-y-2">
                <p>契約締結後、以下の期間で納品いたします：</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>LP・Webサイト制作：1〜2週間</li>
                  <li>業務Webアプリ開発：1〜2ヶ月</li>
                  <li>基幹システム開発：2〜4ヶ月</li>
                </ul>
                <p className="text-sm text-[#7B8794] mt-2">
                  ※プロジェクトの規模・複雑さにより期間は変動いたします。詳細は契約書にて明記いたします。
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                返品・キャンセルについて
              </h2>
              <div className="text-[#5A6577] space-y-3">
                <div>
                  <h3 className="font-semibold mb-2">キャンセルについて</h3>
                  <ul className="list-disc ml-6 space-y-1 text-sm">
                    <li>契約前：キャンセル料は発生いたしません</li>
                    <li>開発開始前：契約金額の10%のキャンセル料</li>
                    <li>
                      開発開始後：完了済み作業分の料金をお支払いいただきます
                    </li>
                  </ul>
                </div>
                <div>
                  <h3 className="font-semibold mb-2">返品について</h3>
                  <p className="text-sm">
                    システム開発は受注生産のため、原則として返品はお受けできません。
                    ただし、契約書に明記された仕様と著しく異なる場合は、無償で修正対応いたします。
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                瑕疵担保責任
              </h2>
              <div className="text-[#5A6577] space-y-2">
                <p>納品後、以下の期間において瑕疵担保責任を負います：</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>システムの不具合：納品後3ヶ月間</li>
                  <li>セキュリティ脆弱性：納品後6ヶ月間</li>
                </ul>
                <p className="text-sm text-[#7B8794] mt-2">
                  ※お客様の使用環境や操作に起因する問題は対象外となります。
                </p>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                個人情報の取扱い
              </h2>
              <p className="text-[#5A6577]">
                お客様の個人情報は、当社の
                <a
                  href="/privacy"
                  className="text-[#B8860B] hover:underline mx-1"
                >
                  プライバシーポリシー
                </a>
                に従って適切に管理いたします。
              </p>
            </div>

            <div className="rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
              <h2 className="text-xl font-bold text-[#2D3748] mb-4 border-b border-[#E8E6E1] pb-2">
                その他
              </h2>
              <div className="text-[#5A6577] space-y-2">
                <ul className="list-disc ml-6 space-y-1">
                  <li>
                    本表記に記載のない事項については、特定商取引法その他の法令に従います
                  </li>
                  <li>
                    紛争が生じた場合は、当社所在地を管轄する裁判所を専属的合意管轄裁判所とします
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-12 rounded-2xl border border-[#E8E6E1] bg-white p-6 shadow-sm">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4">
              お問い合わせ
            </h2>
            <p className="text-[#5A6577] mb-4">
              ご不明な点がございましたら、お気軽にお問い合わせください。
            </p>
            <div className="space-y-2 text-[#5A6577]">
              <p>
                <strong>電話：</strong>082-209-0181（平日 10:00〜17:00）
              </p>
              <p>
                <strong>メール：</strong>
                <span className="select-all">info</span>
                <span className="text-[#7B8794] mx-1">[at]</span>
                <span className="select-all">senrigan</span>
                <span className="text-[#7B8794] mx-1">[dot]</span>
                <span className="select-all">systems</span>
              </p>
              <p className="text-sm text-[#7B8794]">
                ※ [at]を@に、[dot]を.に置き換えてください
              </p>
            </div>
          </div>

          <p className="text-[#7B8794] mt-10 text-sm">制定日：2025年7月1日</p>
        </div>
      </section>
    </div>
  );
};

export default SpecifiedCommercialTransactions;
